import { useUser } from "../_hooks/useUser";

export const TestPage = () : JSX.Element => {

    const { user } = useUser(true);
    
    return <div>TESTSIDA, { user && user.name }</div>
}